import { isAxiosError } from 'axios';

import { Text } from '~/domains/common/components/Text/Text';

export function ErrorNote({ itemKey, error }: { itemKey?: string; error: unknown }) {
  if (!['localhost', 'development'].includes(process.env.NEXT_PUBLIC_ENV)) {
    return null;
  }

  if (isAxiosError(error)) {
    return (
      <div>
        <Text color="gray.5">
          {itemKey && <div>{itemKey}</div>}
          <div>Code: {error.code}</div>
          {error.response && (
            <div>
              <div>Status code: {error.response?.status}</div>
              {(() => {
                const responseMessage = error.response?.data.message;
                if (Array.isArray(responseMessage)) {
                  // eslint-disable-next-line react/no-array-index-key
                  return responseMessage.map((message, index) => <div key={index}>{message}</div>);
                }

                return <div>{responseMessage}</div>;
              })()}
            </div>
          )}
        </Text>
      </div>
    );
  }

  return (
    <div>
      <Text color="gray.5">
        {itemKey && <div>{itemKey}</div>}
        <div>Runtime error</div>
        {error instanceof Error && 'message' in error ? (
          <div>{error.message}</div>
        ) : (
          <div>Unknown error</div>
        )}
      </Text>
    </div>
  );
}
